module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/3056a20b18aeb1ebc83eee8a45005924.png";